export default "assets/images/sowine-dd-0fc2bb42.png";